// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import React, { useContext } from 'react';
import LedgerApiClientV2 from '../utils/LedgerApiClientV2';

export const LedgerApiContextV2 = React.createContext<LedgerApiClientV2 | undefined>(undefined);

export const useLedgerApiClient: () => LedgerApiClientV2 = () => {
  const client = useContext(LedgerApiContextV2);
  if (!client) {
    throw new Error('Ledger API v2 client is not initialized');
  }
  return client;
};
